import Swiper, {Navigation, Scrollbar} from "swiper";

// Uchwyt paska przewijania jest o połowę mniejszy na mobile (grafika 152 × 20 → 76 × 10;
// wysokość ustawia .swiper-scrollbar-drag w s-products.scss, szerokość MUSI iść przez `dragSize`,
// bo Swiper wpisuje ją slajdowi inline).
const mobile = window.matchMedia('(max-width: 767.98px)');
const dragSize = () => mobile.matches ? 76 : 152;

const productsSlider = new Swiper($('.products-slider')[0], {
    // Szerokość slajdu bierzemy z CSS (packshot ma do 400×400), nie z podziału kontenera
    // — patrz .products-slider .swiper-slide w assets/styles/sections/s-products.scss.
    slidesPerView: 'auto',
    // rewind zamiast loop: przy loop + centeredSlides Swiper mapuje pasek przewijania na zakres
    // z klonami, więc uchwyt nie dojeżdżał do krawędzi. rewind zawija na strzałkach bez klonów.
    rewind: true,
    touchRatio: 0.1,
    centeredSlides: true,
    initialSlide: 1,
    navigation: {
        prevEl: $('.products-carousel .swiper-button-prev')[0],
        nextEl: $('.products-carousel .swiper-button-next')[0]
    },
    // Biała linia pod sliderem z przesuwalnym uchwytem (grafika products/scroll.png).
    // dragSize = szerokość grafiki, żeby uchwyt nie skalował się proporcjonalnie do liczby slajdów.
    scrollbar: {
        el: $('.products-scroll')[0],
        draggable: true,
        dragSize: dragSize(),
        hide: false
    },
    modules: [Navigation, Scrollbar]
});

// `dragSize` jest czytany przy przeliczaniu paska, więc po zmianie breakpointa wystarczy
// podmienić parametr i kazać modułowi przemierzyć uchwyt.
mobile.addEventListener('change', () => {
    productsSlider.params.scrollbar.dragSize = dragSize();
    productsSlider.scrollbar.updateSize();
});
